import { Base, base } from "./base"

export type LineHeights = Base

export const lineHeights: LineHeights = {
  ...base
}
